import { IconCropModal } from './IconCropModal';

export default IconCropModal;
